import { useState, type FormEvent } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { authClient } from "../../lib/auth-client";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (!token) {
      setError("Der Link ist unvollständig. Bitte fordere einen neuen an.");
      return;
    }
    setSubmitting(true);
    const { error: resetError } = await authClient.resetPassword({ newPassword, token });
    setSubmitting(false);
    if (resetError) {
      setError("Der Link ist ungültig oder abgelaufen.");
      return;
    }
    void navigate("/login", { replace: true });
  }

  return (
    <div className="pw-centered-page">
      <div className="pw-centered-page__panel pw-card">
        <h1 style={{ margin: "0 0 0.3rem", fontSize: "1.4rem", fontWeight: 600 }}>Neues Passwort festlegen</h1>
        {error && (
          <div className="pw-alert pw-alert--error" role="alert">
            {error}
          </div>
        )}
        <form onSubmit={(e) => void onSubmit(e)} noValidate>
          <div className="pw-field">
            <label htmlFor="newPassword">Neues Passwort (mind. 12 Zeichen)</label>
            <input
              id="newPassword"
              type="password"
              autoComplete="new-password"
              minLength={12}
              required
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="pw-button pw-button--primary" disabled={submitting} style={{ width: "100%" }}>
            {submitting ? "Wird gespeichert …" : "Passwort setzen"}
          </button>
        </form>
        <p style={{ margin: "1rem 0 0", fontSize: "0.8rem", textAlign: "center" }}>
          <Link to="/login">Zurück zur Anmeldung</Link>
        </p>
      </div>
    </div>
  );
}
